const baseCardShared = {
  cursor: 'pointer'
};

const cardHover = {
  '&:hover': {
    boxShadow: 'cardListHover',
    transition: 'box-shadow 0.3s ease, border-color 0.3s ease, transform 0.15s ease-out',
    textDecoration: 'none'
  },
  '&:active': {
    transform: 'scale(0.97)',
    boxShadow: 'none'
  }
};

const base = {
  interactive: {
    ...baseCardShared,
    ...cardHover,
    boxShadow: 'cardList',
    '&:focus, &:focus-within': {
      outline: '3px auto',
      outlineOffset: '8px'
    }
  },
  raised: {
    ...baseCardShared,
    boxShadow: 'cardList'
  },
  template: {
    backgroundColor: 'coolGrey.5',
    padding: 's16'
  }
};

const card = {
  products: {
    chart: base,
    chartblog: base,
    co: base,
    edu: base,
    scale: base,
    spark: base
  }
};

export type CardVariantsType = 'interactive' | 'raised' | 'template';
export const cardVariants = Object.keys(base) as CardVariantsType[];

export default card;
